import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { SwipeToDelete } from "./SwipeToDelete";
import { TodoItem } from "./TodoItem";

type SortableTodoItemProps = {
  id: string;
  title: string;
  checked: boolean;
  quantity?: string | null;
  onToggle: (id: string, checked: boolean) => void;
  onDelete: (id: string) => void;
  onSelect?: (id: string) => void;
};

export const SortableTodoItem = (props: SortableTodoItemProps) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useSortable({
      id: props.id,
      animateLayoutChanges: () => false,
    });

  const style = {
    position: "relative" as const,
    transform: isDragging
      ? `${CSS.Transform.toString(transform)} scale(1.03)`
      : CSS.Transform.toString(transform),
    zIndex: isDragging ? 50 : 0,
    boxShadow: isDragging ? "0 4px 12px rgba(0,0,0,0.15)" : undefined,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <SwipeToDelete onDelete={() => props.onDelete(props.id)}>
        <TodoItem
          id={props.id}
          title={props.title}
          checked={props.checked}
          quantity={props.quantity}
          onToggle={props.onToggle}
          onSelect={props.onSelect}
        />
        <div className="h-px bg-border" />
      </SwipeToDelete>
    </div>
  );
};
